import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children", "info", "underline", "icon", "backgroundColor", "variant", "noWrap"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { jsxs as b, jsx as o } from "react/jsx-runtime";
import { c as r } from "../clsx-OuTLNxxd.js";
import { Icon as _ } from "../Icon/Icon.js";
import { Tab as u } from "react-tabs";
const m = "Tab-module_tab__3tVCB",
  T = "Tab-module_no-wrap__b89ck",
  g = "Tab-module_tab-size-wide__sIYne",
  k = "Tab-module_tab-selected__s92MU",
  B = "Tab-module_tab-underline__39CXU",
  p = "Tab-module_tab-disabled__jEyK1",
  h = "Tab-module_tab-background-destination__6ifiE",
  N = "Tab-module_tab-background-neutral05__67dGn",
  W = "Tab-module_tab-background-white__ztQGm",
  D = "Tab-module_label__GUOFB",
  f = "Tab-module_icon__FwYYD",
  a = {
    tab: m,
    noWrap: T,
    tabSizeWide: g,
    tabSelected: k,
    tabUnderline: B,
    tabDisabled: p,
    tabBackgroundDestination: h,
    tabBackgroundNeutral05: N,
    tabBackgroundWhite: W,
    label: D,
    icon: f
  },
  w = _ref => {
    let {
        children: d,
        info: t,
        underline: l,
        icon: n,
        backgroundColor: e = "neutral05",
        variant: s = "auto",
        noWrap: i
      } = _ref,
      c = _objectWithoutProperties(_ref, _excluded);
    return /* @__PURE__ */b(u, _objectSpread(_objectSpread({}, c), {}, {
      disabledClassName: a.tabDisabled,
      selectedClassName: a.tabSelected,
      className: r(a.tab, {
        [a.noWrap]: i,
        [a.tabUnderline]: l,
        [a.tabSizeWide]: s == "wide",
        [a.tabBackgroundDestination]: e == "destinationExtralight",
        [a.tabBackgroundWhite]: e == "white",
        [a.tabBackgroundNeutral05]: e == "neutral05"
      }),
      children: [/* @__PURE__ */b("div", {
        className: a.label,
        children: [n && /* @__PURE__ */o(_, {
          name: n,
          size: "1.5x",
          padding: !1,
          className: a.icon
        }), d]
      }), t && /* @__PURE__ */o("div", {
        className: a.info,
        children: t
      })]
    }));
  };
w.tabsRole = "Tab";
export { w as Tab };